import {View} from "@/features/km_app/types/View";

export type AmplitudeLocation =
    | "homematch_tinder"
    | "km_favourites"
    | "km_rejected"
    | "homematch"
    | "hm_sent_offers"
    | "km_messages"
    | "hm_favourite_offers_comparison"
    | "km_offer_details"
    | "km_dashboard"
    | "km_favourite_picker";

const viewToLocationMap: Partial<Record<View, AmplitudeLocation>> = {
    [View.HOME_MATCH]: "homematch_tinder",
    [View.FAVORITE]: "km_favourites",
    [View.DISMISSED]: "km_rejected",
    [View.MY_OFFERS]: "homematch",
    [View.MY_OFFER]: "km_offer_details",
    [View.APPLICATION_SENT]: "hm_sent_offers",
    [View.THREAD]: "km_messages",
    [View.COMPARATOR]: "hm_favourite_offers_comparison",
    [View.DASHBOARD]: "km_dashboard"
};

export const getAmplitudeLocationByView = (viewType: View): AmplitudeLocation | undefined => {
    return viewToLocationMap[viewType];
};
import {View} from "@/features/km_app/types/View";

export type AmplitudeLocation =
    | "homematch_tinder"
    | "km_favourites"
    | "km_rejected"
    | "homematch"
    | "hm_sent_offers"
    | "km_messages"
    | "hm_favourite_offers_comparison"
    | "km_offer_details"
    | "km_dashboard"
    | "km_favourite_picker";

const viewToLocationMap: Partial<Record<View, AmplitudeLocation>> = {
    [View.HOME_MATCH]: "homematch_tinder",
    [View.FAVORITE]: "km_favourites",
    [View.DISMISSED]: "km_rejected",
    [View.MY_OFFERS]: "homematch",
    [View.MY_OFFER]: "km_offer_details",
    [View.APPLICATION_SENT]: "hm_sent_offers",
    [View.THREAD]: "km_messages",
    [View.COMPARATOR]: "hm_favourite_offers_comparison",
    [View.DASHBOARD]: "km_dashboard"
};

export const getAmplitudeLocationByView = (viewType: View): AmplitudeLocation | undefined => {
    return viewToLocationMap[viewType];
};
